import {useState} from "react";
import {useQuery} from "react-query";
// import axios from "services/axios";
import dayjs from "dayjs";

// Temporary dummy dataset; replace with axios calls when API is ready
const DUMMY_KEYS = [
	{
		id: 1,
		name: "Default Integration",
		key: "pk_live_1234567890abcdef1234567890abcd",
		createdAt: dayjs().subtract(10, "day").toISOString(),
		status: "Active",
	},
	{
		id: 2,
		name: "Mobile App",
		key: "pk_live_abcdef1234567890abcdef1234567890",
		createdAt: dayjs().subtract(3, "day").toISOString(),
		status: "Inactive",
	},
	{
		id: 3,
		name: "Partner X",
		key: "pk_live_PARTNERX1234567890abcdef12345678",
		createdAt: dayjs().subtract(1, "day").toISOString(),
		status: "Active",
	},
];

async function getApiKeys(id, params) {
	// Real API example (uncomment when backend ready):
	// if (!id) {
	//   const {data} = await axios.get(`/api-keys`, {params});
	//   return data;
	// }
	// const {data} = await axios.get(`/api-keys/${id}`);
	// return data;

	// Dummy response with simple filtering/pagination
	const {search = null, page = 1, limit = 10} = params || {};
	let rows = DUMMY_KEYS;
	if (search) {
		rows = rows.filter(k => k.name.toLowerCase().includes(String(search).toLowerCase()));
	}
	const totalItems = rows.length;
	const totalPages = Math.max(1, Math.ceil(totalItems / limit));
	const start = (page - 1) * limit;
	const pagedRows = rows.slice(start, start + limit);

	return {
		success: true,
		data: {
			rows: pagedRows,
			totalItems,
			totalPages,
			currentPage: page,
		},
	};
}

export function useApiKeyList() {
	const [params, setParams] = useState({page: 1, search: null, limit: 10, sortBy: "id.desc"});
	const [apiKeyId, setApiKeyId] = useState(null);
	const fallback = [];

	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["apiKeyList", params, apiKeyId], async () => getApiKeys(apiKeyId, params));

	return {data, isLoading, isError, error, params, setParams, setApiKeyId};
}
